import firebase from 'firebase'



export default function getItemsForUser(userUid, projectId){
  let saveObject = {};
  let saveJobs = {};
  let saveJobsByObject = {};
  let company = {}
  let user = {};
  let initData = false;
  let promiseInitDB;
  return myFirestore
    .collection('projects')
    .doc(projectId)
    .collection('users')
    .where('uid', '==', userUid)
    .get()
    .then((response) => {
      const resultUser = []

      response.forEach(sub => {
        resultUser.push(sub.data())
      })
      user = resultUser[0];

      return myFirestore
        .collection('projects')
        .doc(projectId)
        .collection('users')
        .where('isCompany', '==', true)
        .where('name', '==', resultUser[0].company)
        .get()
    }).then((response) => {
    const result = []

      response.forEach(sub => {
        result.push(sub.data())
      })
      if (result.length === 0) {
        initData = true
        company = result[0];
        user.role = 'admin'
        return {saveObject, saveJobs, company, user, saveJobsByObject}
      }
      if (!result[0].available_jobs || !result[0].available_objects) {
        initData = true
        company = result[0];
        user.role = 'admin'
        return {saveObject, saveJobs, company, user, saveJobsByObject}
      }

      if (result[0].usePermission === false) {
        initData = true
        company = result[0];
        user.role = 'admin'
      }
      Object.entries(result[0].available_jobs).reduce((acum, [key, val]) => {
        acum[key] = val
        val.reduce((a, i) => (a[i] = true, a), saveJobs)
        return acum
      }, saveJobsByObject)

      result[0].available_objects.reduce((acum, item) => {
        acum[item] = true
        return acum
      }, saveObject)
      initData = true
      company = result[0];
      return {saveObject, saveJobs, company, user, saveJobsByObject}
    }).then((r) => {
      return r;
    });

    // return getFromDb
  // if (!initData) {
  //   if (promiseInitDB) {
  //     return promiseInitDB;
  //   }
  //   promiseInitDB = getFromDb
  //   return promiseInitDB.then(r => {
  //     console.log(r, r.user.role)
  //     return r;
  //   });
  // }
  //
  // return new Promise((resolve) =>
  //   resolve({saveObject, saveJobs, company, user})
  // )
}

export function resetInit(){
  // initData = false;
  // promiseInitDB = undefined;
  // saveObject = {};
  // saveJobs = {};
  // company = {};
  // user = {};
}



// WEBPACK FOOTER //
// ./src/utils/getItemsForUser.js